var render = function render(){var _vm=this,_c=_vm._self._c;return _c('commonIframe',{attrs:{"hashCode":"saasLineManage"},on:{"page":_vm.newPage,"removePage":_vm.closeAndNew}})
}
var staticRenderFns = []

export { render, staticRenderFns }